let filters = {};

// 保留两位小数点
filters.number = (value) => {
  return  Number(value).toFixed(2);
};
// 返回时间距离今天的天数 
filters.enddate = (endday) => {
    var sdate =new Date(endday);
    var now = new Date();
    var dayDiff = sdate.getTime() - now.getTime();
    var day = Math.ceil(dayDiff / (1000 * 60 * 60 * 24));
    if (day >= 0) return day;
    return '应用已过期';
}; 

export default filters





// WEBPACK FOOTER //
// ./src/filters/index.js